import { FC } from 'react'

import MTravelLogoWhite from '/mtravel_full_white.svg'

// import MTravelLogo from '/logo_full.svg'
// import MTravelLogo from 'shared/icons/new_year_logo.svg'
import { onCloseApp } from 'shared/lib//closeApp'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { Header } from 'shared/ui/header'
import { ImageLazy } from 'shared/ui/image-lazy'

import { HeaderVariant } from '../header/header'

import s from './styles.module.scss'

interface Props {
  title?: string
  headerVariant?: HeaderVariant
  backgroundColor?: string
  isFixed?: boolean
}

export const HeaderWithIcon: FC<Props> = ({
  title,
  headerVariant = 'grey',
  backgroundColor,
  isFixed,
}) => {
  const onCloseAppHandler = () => {
    onCloseApp()
  }

  return (
    <div className={s.container}>
      <Header
        title={title}
        variant={headerVariant}
        backgroundColor={backgroundColor}
        isFixed={isFixed}
        actionLeft={
          <AppIcon
            id={AllIcons.CROSS}
            className={s[`${headerVariant}_icon`]}
            width={24}
            height={24}
            onClick={onCloseAppHandler}
          />
        }
      >
        <ImageLazy
          alt="logo"
          src={MTravelLogoWhite}
          className={s.logo}
        />
      </Header>
    </div>
  )
}
